<template>
  <div>
    <span class="caption mr-1">
      <a
        :style="style"
        :href="`/terms-and-conditions/${locale()}`"
        target="_blank"
        >{{ $t('titles.global.termsAndConditions') }}</a
      >
      |
      <a :style="style" :href="`/terms-of-use/${locale()}`" target="_blank">{{
        $t('titles.global.termsOfUse')
      }}</a>
      |
      <a :style="style" :href="`/cookies/${locale()}`" target="_blank">{{
        $t('titles.global.cookiesPolicy')
      }}</a>
    </span>
  </div>
</template>

<script>
export default {
  name: 'TermsDialog',
  props: {
    login: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      terms: false,
      policy: false,
    }
  },
  computed: {
    style() {
      return this.login ? 'color: white !important;' : ''
    },
  },
  methods: {
    locale() {
      return this.$store.state.languages.locale()
    },
  },
}
</script>
